document.addEventListener("DOMContentLoaded", function () {
  let slider;
  function initSlider(){
    if(window.innerWidth < 750){
      if(!slider){
        slider = new Swiper(".custom-slider", {
          slidesPerView: "auto",
          spaceBetween: 16,
          slidesOffsetAfter: 20,
          scrollbar: {
    el: ".swiper-scrollbar",
    draggable: true,
  },
        });
      }
    } else {
      if(slider){
        slider.destroy(true, true);
        slider = undefined;
      }
    }
  }
  initSlider();
  window.addEventListener("resize", initSlider);
});